<template>
  <ZMainPage :loading="loading" type="card">
    <div v-if="$route.query.show === '0'" style="width: 99%;height: 349px;background: #FFFFFF;border-radius: 8rem;display: flex;align-items: center">
      <t-result style="" text="还没有数据提交上来哦" type="empty"></t-result>
    </div>
    <template v-else>
      <div class="z-box-bg mb-2">
        <div class="user-info">
          <div class="lf">
            <div class="top">
              <el-image class="img" :preview-src-list="[info.photo]" :src="info.photo" fit="cover">
                <template #error>
                  <img style="width: 100%;height: 100%" src="@/assets/img/default-header.png"/>
                </template>
              </el-image>
              <div class="card">
                <div class="item" :class="item.type" v-for="(item, idx) in userInfo" :key="idx">
                  <div class="label">
                    {{ item.label }}
                    <el-icon v-if="item.icon" :class="[item.icon]" :style="{ color: item.color, fontSize: '20rem' }"></el-icon>
                  </div>
                  <div class="value">{{ info[item.value] }}</div>
                  <img class="img" :src="`/img/moral/teacher-work/${item.type}.png`" alt="">
                </div>
              </div>
            </div>
            <div class="line"></div>
            <div class="bot">
              <div class="item" v-for="(item, idx) in userDetail" :key="idx">
                <div class="label">{{ item.label }}</div>
                <div class="value">
                  <el-icon v-if="item.icon" :class="[item.status ? 'el-icon-s-claim' : 'el-icon-s-release', `s${item.status}`]" style="font-size: 20rem"></el-icon>
                  {{ info[item.value] }}
                </div>
              </div>
            </div>
          </div>
          <div class="rt">
            <div class="item" v-for="(item, idx) in userHealth" :key="idx">
              <div class="top">
                <div class="title">{{ item.label }}</div>
                <div class="tips">
                  {{ item.value }}
                  <el-icon :class="[item.value === '有' ? 'el-icon-success' : 'el-icon-remove', `s${item.value === '有' ? 1 : 2}`]"></el-icon>
                </div>
              </div>
              <div class="content">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="z-box-bg mb-2">
        <div class="info-list">
          <div class="item" v-for="(item, idx) in userPsychological" :key="idx">
            <div class="title">{{ item.label }}</div>
            <div class="content">{{ info[item.value] }}</div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <el-button type="primary" @click="$router.back()">返回</el-button>
    </template>
  </ZMainPage>
</template>

<script>
import TResult from "@/components/Result.vue";


export default {
  components: {TResult},
  _config:{"route":{"path":"edit","meta":{"title":"查看","style":0}}},
  data() {
    return {
      info: {},
      userInfo: [],
      userDetail: [],
      userHealth: [],
      userPsychological: [],
    }
  },
  created() {
    this.$_axios2.get('/api/work/teacher-class/talk-details?id=' + this.$route.query.id).then(res => {
      const data = res.data.data
      this.info = res.data.data
      let icon = '', color = ''
      if (data.student_gender_text === '男') {
        icon = 'el-icon-male'
        color = '#4C73FF'
      } else {
        icon = 'el-icon-female'
        color = '#FF71B1'
      }
      this.userInfo = [
        { label: data.student_name, value: 'student_no', type: 'c1', color, icon },
        { label: '希望学习外语语种', value: 'optional_languages', type: 'c2' },
        { label: '是否考虑多元升学', value: 'muti_study', type: 'c3' },
        { label: '父亲职业', value: 'father_job', type: 'c4' },
        { label: '是否为独生子女', value: 'only_child', type: 'c5' },
        { label: '希望学习学科组合', value: 'choose_subject', type: 'c2' },
        { label: '是否有出国经历', value: 'is_chuguo', type: 'c3' },
        { label: '母亲职业', value: 'mother_job', type: 'c4' },
      ]
      this.userDetail = [
        { label: '校区', value: 'school' },
        { label: '年级', value: 'grade' },
        { label: '行政班', value: 'class_name' },
        { label: '谈话人', value: 'teacher' },
        { label: '状态', value: 'status_text', icon: 1, status: data.status === 2 ? 1 : 0 },
      ]
      this.userHealth = [
        { label: '是否有过敏体质', value: data.allergy, content: data.allergy_details || (data.allergy === '有' ? '' : '无过敏体质') },
        { label: '是否有重大疾病', value: data.serious_ill, content: data.serious_ill_details || (data.serious_ill === '有' ? '' : '无重大疾病') },
        { label: '是否有心理障碍', value: data.psychological_disorders, content: data.psychological_disorders_details || (data.psychological_disorders === '有' ?  '' : '无心理障碍') },
      ]
      this.userPsychological = [
        { label: '各科目学习情况', value: 'subject_study' },
        { label: '学生高考目标', value: 'student_target' },
        { label: '职业规划', value: 'career_planning' },
        { label: '同伴关系', value: 'companion_relationship' },
        { label: '寝室关系', value: 'dorm_relationship' },
        { label: '师生关系', value: 'teacher_student_relationship' },
        { label: '家庭情况', value: 'home_details' },
        { label: '优点自评、缺点剖析', value: 'advantage_shortcoming' },
      ]
    })
  }
}
</script>

<style scoped lang="scss">
.user-info {
  padding-top: 30rem;
  display: flex;
  justify-content: space-between;
  gap: 24rem;

  .s0 {
    color: #F76560;
  }
  .s1 {
    color: #23C343;
  }
  .s2 {
    color: #F6AD3C;
  }
  .lf {
    width: 1000rem;
    flex-shrink: 0;
    .top {
      padding-bottom: 30rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 24rem;
    }
    .img {
      width: 175rem;
      height: 240rem;
      flex-shrink: 0;
      border-radius: 8rem;
    }
    .card {
      flex: 1;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 24rem;
      .item {
        position: relative;
        height: 92rem;
        padding: 20rem 18rem;
        border-radius: 8rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &.c1 {
          background-color: #FCF5F6;
          .value {
            font-weight: 400;
          }
        }
        &.c2 {
          background-color: #ECF3EE;
          .value {
            color: #548757;
          }
        }
        &.c3 {
          background-color: #E9F2FE;
          .value {
            color: #487FFB;
          }
        }
        &.c4 {
          background-color: #F3F3FA;
          .value {
            color: #3D33AA;
          }
        }
        &.c5 {
          background-color: #F9F4E8;
          .value {
            color: #CD993E;
          }
        }
      }
      .label {
        font-size: 16rem;
        color: #333;
      }
      .value {
        font-size: 15rem;
        color: #665B5D;
        font-weight: 500;
      }
      .img {
        position: absolute;
        top: 0;
        right: 0;
        width: 69rem;
        height: 48rem;
      }
    }
    .line {
      height: 2rem;
      margin-bottom: 24rem;
      background-color: #F6F9FF;
    }
    .bot {
      display: flex;
      justify-content: space-between;
      gap: 24rem;
      .item {
        position: relative;
        font-size: 16rem;
        padding: 0 20rem;
      }
      .label {
        margin-bottom: 10rem;
        color: #666;
      }
      .value {
        color: #333;
        font-weight: 500;
      }
    }
  }
  .rt {
    flex: 1;
    .item {
      position: relative;
      padding: 10rem 0 10rem 34rem;
      &:not(:last-child) {
        margin-bottom: 10rem;
      }
      &::before, &::after {
        content: '';
        position: absolute;
        background-color: #3D3D3D;
        border-radius: 50%;
        margin-bottom: 10rem;
      }
      &::before {
        top: 16rem;
        left: 14rem;
        width: 8rem;
        height: 8rem;
        background-color: #1C4EFD;
        border-radius: 50%;
      }
      &::after {
        top: 36rem;
        left: 17rem;
        bottom: 0;
        width: 2rem;
        background-color: #EAF1FD;
      }
    }
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 24rem;
      font-size: 16rem;
      margin-bottom: 10rem;
      .title {
        color: #333;
        font-weight: 500;
      }
      .tips {
        color: #3D3D3D;
      }
    }
    .content {
      min-height: 52rem;
      padding: 12rem;
      font-size: 12rem;
      background-color: #F6F9FF;
      color: #666;
      border-radius: 4rem;
    }
  }
}
.info-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24rem;
  .item {
    padding-top: 8rem;
    background-color: #F7F7F7;
    border-radius: 6rem;
    .title {
      padding: 0 14rem;
      font-size: 16rem;
      line-height: 30rem;
      color: #fff;
      font-weight: 500;
      background-color: #76ACFC;
      border-radius: 0 30rem 30rem 0;
      display: inline-block;
    }
    .content {
      padding: 14rem;
      color: #333;
      font-size: 14rem;
    }
  }
}
</style>
